module.exports = __webpack_public_path__ + "img/5.1887d3fa.gif";